import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { ProfileComponent } from './profile.component';
import { ProfileService } from '@fuse/services/profile.service';
import { MatButtonModule, MatIconModule, MatDividerModule, MatTabsModule, MatFormFieldModule, MatInputModule, MatSnackBarModule, MatTableModule, MatSortModule, MatPaginatorModule, MatBadgeModule, MatRadioModule, MatCheckboxModule, MatSelectModule, MatChipsModule, MatToolbarModule, MatDatepickerModule, MatTooltipModule } from '@angular/material';
import { FuseUploadService } from '@fuse/components/upload/upload.service';
import { FuseUploadModule } from '@fuse/components/upload/upload.module';


const routes = [
    {
        path: 'profile',
        component: ProfileComponent,
        pathMatch: 'full',
        resolve: {
            data: ProfileService
        }
    }
];

@NgModule({
    declarations: [
        ProfileComponent,
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        FuseUploadModule,

        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSnackBarModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatBadgeModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        MatChipsModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatTooltipModule
    ],
    exports: [
        ProfileComponent
    ],
    providers: [
        ProfileService,
        FuseUploadService
    ],
    entryComponents: [

    ]
})

export class ProfileModule {
}

